import * as rateHelpers from "./rateHelpers";
import cn from "../../lib/classnames";
import React from "react";
import Star from "./Star";
import styles from "./StarRating.module.css";

const strings = {
    label5: "5 Stars",
    label4: "4 Stars",
    label3: "3 Stars",
    label2: "2 Stars",
    label1: "1 Star",
    label0: "No rating.",
};

type Props = {
    value: number;
    setValue: (n: number) => void;
    className?: string;
};

const INPUT_NAME = "rating";
const STAR_5 = {id: "star5", value: rateHelpers.Rating.Five, label: strings.label5};
const STAR_4 = {id: "star4", value: rateHelpers.Rating.Four, label: strings.label4};
const STAR_3 = {id: "star3", value: rateHelpers.Rating.Three, label: strings.label3};
const STAR_2 = {id: "star2", value: rateHelpers.Rating.Two, label: strings.label2};
const STAR_1 = {id: "star1", value: rateHelpers.Rating.One, label: strings.label1};
const STAR_0 = {id: "no-rate", value: rateHelpers.Rating.None, label: strings.label0};

const STARS = [STAR_1, STAR_2, STAR_3, STAR_4, STAR_5];

export default function StarRating(props: Props) {
    let ratingValue = rateHelpers.Rating.None;
    const stringValue = `${props.value}`;
    if (rateHelpers.isRating(stringValue)) {
        ratingValue = stringValue;
    }
    return (
        <fieldset className={cn(styles.starRating, props.className)}>
            <input
                aria-label={strings.label0}
                checked={ratingValue === STAR_0.value}
                className={styles.noRate}
                id={STAR_0.id}
                name={INPUT_NAME}
                onChange={(e) => {
                    if (e.currentTarget.value === STAR_0.value) {
                        props.setValue(0);
                    }
                }}
                type="radio"
                value={STAR_0.value}
            />

            {STARS.map((star) => (
                <Star
                    id={star.id}
                    key={star.id}
                    label={star.label}
                    name={INPUT_NAME}
                    setValue={(v) => props.setValue(rateHelpers.getNumber(v))}
                    value={star.value}
                    selectedValue={ratingValue}
                />
            ))}

            <div className={styles.focusRing}></div>
        </fieldset>
    );
}
